export default "__VITE_ASSET__B_Vwq5gx__"